import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styled from "styled-components";
import { COLOR_RED, COLOR_WHITE } from "../constants/colors";
import { Body1, Body2, Subtitle2 } from "./Typography";

type InputPhoneProps = {
  label: string;
  value: string;
  placeholder: string;
  onChange: (value: string, phoneData: CountryData) => void;
  error?: string;
};

const Label = styled.label`
  ${Body1}
  color: ${COLOR_WHITE};
`;

const Error = styled.div`
  ${Body2}
  color: ${COLOR_WHITE};
`;

const StyledPhoneInput = styled(PhoneInput)`
  ${Subtitle2}
`;

function InputPhone(props: InputPhoneProps) {
  const { label, value, placeholder, error, onChange } = props;

  return (
    <>
      <Label className="mb-2">{label}</Label>
      <StyledPhoneInput
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        enableSearch
        containerStyle={
          error
            ? {
                borderRadius: "12px",
                border: `2px solid ${COLOR_RED}`,
              }
            : {}
        }
      />
      {error && <Error className="mt-1">{error}</Error>}
    </>
  );
}

export default InputPhone;

InputPhone.defaultProps = {
  error: "",
};
